import React from "react";

import TourRunner from "../base/TourRunner";

import { plannerTourConfiguration } from "./configuration";

const PlannerTour = () => {
  return <TourRunner descriptor={plannerTourConfiguration} />;
};

export default PlannerTour;
